/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  AccessToken,
  BulkResult,
  BulkUpdateStatus,
  Courier,
  CourierPackage,
  CourierPackageImportFromJaShippersRequest,
  CourierPackageImportPackagesFromCsvRequest,
  CourierPackageMarkAsDeliveredRequest,
  CourierPackageUpdatePackageStatusRequest,
  CourierSettings,
  CourierUser,
  CourierUserCreateWhatsAppUserRequest,
  Invoice,
  NewCourierPackage,
  NewCourierUser,
  NewRole,
  NewRoleMapping,
  Role,
  RoleMapping,
  RoleMappingCount200Response,
  RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest,
  RoleMappingExistsGetRoleMappingsIdExists200Response,
  RoleMappingUpdateAll200Response,
  StoreLocation,
} from '../models/index';
import {
  AccessTokenFromJSON,
  AccessTokenToJSON,
  BulkResultFromJSON,
  BulkResultToJSON,
  BulkUpdateStatusFromJSON,
  BulkUpdateStatusToJSON,
  CourierFromJSON,
  CourierToJSON,
  CourierPackageFromJSON,
  CourierPackageToJSON,
  CourierPackageImportFromJaShippersRequestFromJSON,
  CourierPackageImportFromJaShippersRequestToJSON,
  CourierPackageImportPackagesFromCsvRequestFromJSON,
  CourierPackageImportPackagesFromCsvRequestToJSON,
  CourierPackageMarkAsDeliveredRequestFromJSON,
  CourierPackageMarkAsDeliveredRequestToJSON,
  CourierPackageUpdatePackageStatusRequestFromJSON,
  CourierPackageUpdatePackageStatusRequestToJSON,
  CourierSettingsFromJSON,
  CourierSettingsToJSON,
  CourierUserFromJSON,
  CourierUserToJSON,
  CourierUserCreateWhatsAppUserRequestFromJSON,
  CourierUserCreateWhatsAppUserRequestToJSON,
  InvoiceFromJSON,
  InvoiceToJSON,
  NewCourierPackageFromJSON,
  NewCourierPackageToJSON,
  NewCourierUserFromJSON,
  NewCourierUserToJSON,
  NewRoleFromJSON,
  NewRoleToJSON,
  NewRoleMappingFromJSON,
  NewRoleMappingToJSON,
  RoleFromJSON,
  RoleToJSON,
  RoleMappingFromJSON,
  RoleMappingToJSON,
  RoleMappingCount200ResponseFromJSON,
  RoleMappingCount200ResponseToJSON,
  RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestFromJSON,
  RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON,
  RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON,
  RoleMappingExistsGetRoleMappingsIdExists200ResponseToJSON,
  RoleMappingUpdateAll200ResponseFromJSON,
  RoleMappingUpdateAll200ResponseToJSON,
  StoreLocationFromJSON,
  StoreLocationToJSON,
} from '../models/index';

/** Result of dismissing a SmartScan invoice-review flag. */
export interface CourierPackageDismissInvoiceReviewResult {
  id: number;
  needsInvoiceReview: boolean;
  invoiceReviewDismissedBy?: number;
  invoiceReviewDismissedAt?: string;
}

/** Outcome of one SmartScan invoice-review sweep. */
export interface CourierPackageInvoiceReviewSweepResult {
  couriers: number;
  scanned: number;
  assessed: number;
  flagged: number;
  cleared: number;
  skipped: number;
  failed: number;
}

export interface CourierPackageApplyLateFeesRequest {
  courierPackageImportFromJaShippersRequest: CourierPackageImportFromJaShippersRequest;
}

export interface CourierPackageBulkUpdateStatusV2Request {
  bulkUpdateStatus: BulkUpdateStatus;
}

export interface CourierPackageCountRequest {
  where?: string;
}

export interface CourierPackageCreateRequest {
  data?: NewCourierPackage;
}

export interface CourierPackageCreateChangeStreamGetCourierPackagesChangeStreamRequest {
  options?: string;
}

export interface CourierPackageCreateChangeStreamPostCourierPackagesChangeStreamRequest {
  roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest?: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest;
}

export interface CourierPackageDeleteByIdRequest {
  id: string;
}

export interface CourierPackageExistsGetCourierPackagesidExistsRequest {
  id: string;
}

export interface CourierPackageExistsHeadCourierPackagesidRequest {
  id: string;
}

export interface CourierPackageExportPackagesToCsvRequest {
  courierId: string;
}

export interface CourierPackageFindRequest {
  filter?: string;
}

export interface CourierPackageFindByIdRequest {
  id: string;
  filter?: string;
}

export interface CourierPackageFindOneRequest {
  filter?: string;
}

export interface CourierPackageImportFromJaShippersOperationRequest {
  courierPackageImportFromJaShippersRequest: CourierPackageImportFromJaShippersRequest;
}

export interface CourierPackageImportFromJsonWithEmailRequest {
  courierId: string;
  cPackages?: object;
}

export interface CourierPackageImportPackagesFromCsvOperationRequest {
  courierPackageImportPackagesFromCsvRequest?: CourierPackageImportPackagesFromCsvRequest;
}

export interface CourierPackageImportPackagesFromCsvV2Request {
  importData?: object;
}

export interface CourierPackageImportPackagesFromCsvFuzzyMatchRequest {
  courierId: string;
  fileName: string;
}

export interface CourierPackageMarkAsDeliveredOperationRequest {
  courierPackageMarkAsDeliveredRequest?: CourierPackageMarkAsDeliveredRequest;
}

export interface CourierPackagePatchOrCreateRequest {
  data?: CourierPackage;
}

export interface CourierPackagePrototypeCountOwnerAccessTokensRequest {
  id: string;
  where?: string;
}

export interface CourierPackagePrototypeCountOwnerCourierPackagesRequest {
  id: string;
  where?: string;
}

export interface CourierPackagePrototypeCountOwnerReferrerRequest {
  id: string;
  where?: string;
}

export interface CourierPackagePrototypeCountOwnerRoleMappingsRequest {
  id: string;
  where?: string;
}

export interface CourierPackagePrototypeCountOwnerRolesRequest {
  id: string;
  where?: string;
}

export interface CourierPackagePrototypeCreateCourierCourierSettingRequest {
  id: string;
  data?: CourierSettings;
}

export interface CourierPackagePrototypeCreateInvoiceRequest {
  id: string;
  data?: Invoice;
}

export interface CourierPackagePrototypeCreateOwnerAccessTokensRequest {
  id: string;
  data?: AccessToken;
}

export interface CourierPackagePrototypeCreateOwnerCourierPackagesRequest {
  id: string;
  data?: NewCourierPackage;
}

export interface CourierPackagePrototypeCreateOwnerReferrerRequest {
  id: string;
  data?: NewCourierUser;
}

export interface CourierPackagePrototypeCreateOwnerRoleMappingsRequest {
  id: string;
  data?: NewRoleMapping;
}

export interface CourierPackagePrototypeCreateOwnerRolesRequest {
  id: string;
  data?: NewRole;
}

export interface CourierPackagePrototypeDeleteOwnerAccessTokensRequest {
  id: string;
}

export interface CourierPackagePrototypeDeleteOwnerCourierPackagesRequest {
  id: string;
}

export interface CourierPackagePrototypeDeleteOwnerReferrerRequest {
  id: string;
}

export interface CourierPackagePrototypeDeleteOwnerRoleMappingsRequest {
  id: string;
}

export interface CourierPackagePrototypeDeleteOwnerRolesRequest {
  id: string;
}

export interface CourierPackagePrototypeDestroyByIdOwnerAccessTokensRequest {
  id: string;
  fk: string;
}

export interface CourierPackagePrototypeDestroyByIdOwnerCourierPackagesRequest {
  id: string;
  fk: string;
}

export interface CourierPackagePrototypeDestroyByIdOwnerReferrerRequest {
  id: string;
  fk: string;
}

export interface CourierPackagePrototypeDestroyByIdOwnerRoleMappingsRequest {
  id: string;
  fk: string;
}

export interface CourierPackagePrototypeDestroyByIdOwnerRolesRequest {
  id: string;
  fk: string;
}

export interface CourierPackagePrototypeDestroyCourierCourierSettingRequest {
  id: string;
}

export interface CourierPackagePrototypeDestroyInvoiceRequest {
  id: string;
}

export interface CourierPackagePrototypeExistsOwnerRolesRequest {
  id: string;
  fk: string;
}

export interface CourierPackagePrototypeFindByIdOwnerAccessTokensRequest {
  id: string;
  fk: string;
}

export interface CourierPackagePrototypeFindByIdOwnerCourierPackagesRequest {
  id: string;
  fk: string;
}

export interface CourierPackagePrototypeFindByIdOwnerReferrerRequest {
  id: string;
  fk: string;
}

export interface CourierPackagePrototypeFindByIdOwnerRoleMappingsRequest {
  id: string;
  fk: string;
}

export interface CourierPackagePrototypeFindByIdOwnerRolesRequest {
  id: string;
  fk: string;
}

export interface CourierPackagePrototypeGetCourierRequest {
  id: string;
  refresh?: boolean;
}

export interface CourierPackagePrototypeGetCourierCourierSettingRequest {
  id: string;
  refresh?: boolean;
}

export interface CourierPackagePrototypeGetInvoiceRequest {
  id: string;
  refresh?: boolean;
}

export interface CourierPackagePrototypeGetInvoiceBusinessRequest {
  id: string;
  refresh?: boolean;
}

export interface CourierPackagePrototypeGetInvoiceCourierPackageRequest {
  id: string;
  refresh?: boolean;
}

export interface CourierPackagePrototypeGetInvoiceCustomerRequest {
  id: string;
  refresh?: boolean;
}

export interface CourierPackagePrototypeGetOwnerRequest {
  id: string;
  refresh?: boolean;
}

export interface CourierPackagePrototypeGetOwnerAccessTokensRequest {
  id: string;
  filter?: string;
}

export interface CourierPackagePrototypeGetOwnerCourierPackagesRequest {
  id: string;
  filter?: string;
}

export interface CourierPackagePrototypeGetOwnerReferrerRequest {
  id: string;
  filter?: string;
}

export interface CourierPackagePrototypeGetOwnerRoleMappingsRequest {
  id: string;
  filter?: string;
}

export interface CourierPackagePrototypeGetOwnerRolesRequest {
  id: string;
  filter?: string;
}

export interface CourierPackagePrototypeGetStoreLocationRequest {
  id: string;
  refresh?: boolean;
}

export interface CourierPackagePrototypeLinkOwnerRolesRequest {
  id: string;
  fk: string;
  data?: RoleMapping;
}

export interface CourierPackagePrototypePatchAttributesRequest {
  id: string;
  data?: CourierPackage;
}

export interface CourierPackagePrototypeUnlinkOwnerRolesRequest {
  id: string;
  fk: string;
}

export interface CourierPackagePrototypeUpdateByIdOwnerAccessTokensRequest {
  id: string;
  fk: string;
  data?: AccessToken;
}

export interface CourierPackagePrototypeUpdateByIdOwnerCourierPackagesRequest {
  id: string;
  fk: string;
  data?: CourierPackage;
}

export interface CourierPackagePrototypeUpdateByIdOwnerReferrerRequest {
  id: string;
  fk: string;
  data?: CourierUser;
}

export interface CourierPackagePrototypeUpdateByIdOwnerRoleMappingsRequest {
  id: string;
  fk: string;
  data?: RoleMapping;
}

export interface CourierPackagePrototypeUpdateByIdOwnerRolesRequest {
  id: string;
  fk: string;
  data?: Role;
}

export interface CourierPackagePrototypeUpdateCourierCourierSettingRequest {
  id: string;
  data?: CourierSettings;
}

export interface CourierPackagePrototypeUpdateInvoiceRequest {
  id: string;
  data?: Invoice;
}

export interface CourierPackageReplaceByIdPostCourierPackagesidReplaceRequest {
  id: string;
  data?: CourierPackage;
}

export interface CourierPackageReplaceByIdPutCourierPackagesidRequest {
  id: string;
  data?: CourierPackage;
}

export interface CourierPackageReplaceOrCreatePostCourierPackagesReplaceOrCreateRequest {
  data?: CourierPackage;
}

export interface CourierPackageReplaceOrCreatePutCourierPackagesRequest {
  data?: CourierPackage;
}

export interface CourierPackageTrackViaWhatsAppRequest {
  courierUserCreateWhatsAppUserRequest?: CourierUserCreateWhatsAppUserRequest;
}

export interface CourierPackageUpdateAllRequest {
  where?: string;
  data?: CourierPackage;
}

export interface CourierPackageUpdatePackageStatusOperationRequest {
  courierPackageUpdatePackageStatusRequest?: CourierPackageUpdatePackageStatusRequest;
}

export interface CourierPackageUpsertWithWhereRequest {
  where?: string;
  data?: CourierPackage;
}

export interface CourierPackageUpdateAttachmentsRequest {
  packageId: string;
  value: number;
  attachments: Array<string>;
}

export interface CourierPackageGenerateLabelPDFRequest {
  packageId: number;
}

export interface CourierPackageGenerateBulkLabelsRequest {
  packageIds: Array<number>;
}

/**
 *
 */
export class CourierPackageApi extends runtime.BaseAPI {
  /**
   * Apply late fees to packages that are past their due date
   */
  async courierPackageApplyLateFeesRaw(
    requestParameters: CourierPackageApplyLateFeesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<number>> {
    if (
      requestParameters['courierPackageImportFromJaShippersRequest'] == null
    ) {
      throw new runtime.RequiredError(
        'courierPackageImportFromJaShippersRequest',
        'Required parameter "courierPackageImportFromJaShippersRequest" was null or undefined when calling courierPackageApplyLateFees().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/applyLateFees`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CourierPackageImportFromJaShippersRequestToJSON(
          requestParameters['courierPackageImportFromJaShippersRequest']
        ),
      },
      initOverrides
    );

    if (this.isJsonMime(response.headers.get('content-type'))) {
      return new runtime.JSONApiResponse<number>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Apply late fees to packages that are past their due date
   */
  async courierPackageApplyLateFees(
    requestParameters: CourierPackageApplyLateFeesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<number> {
    const response = await this.courierPackageApplyLateFeesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   */
  async courierPackageBulkUpdateStatusV2Raw(
    requestParameters: CourierPackageBulkUpdateStatusV2Request,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<BulkResult>> {
    if (requestParameters['bulkUpdateStatus'] == null) {
      throw new runtime.RequiredError(
        'bulkUpdateStatus',
        'Required parameter "bulkUpdateStatus" was null or undefined when calling courierPackageBulkUpdateStatusV2().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/bulkUpdateStatusV2`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: BulkUpdateStatusToJSON(requestParameters['bulkUpdateStatus']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      BulkResultFromJSON(jsonValue)
    );
  }

  /**
   */
  async courierPackageBulkUpdateStatusV2(
    requestParameters: CourierPackageBulkUpdateStatusV2Request,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<BulkResult> {
    const response = await this.courierPackageBulkUpdateStatusV2Raw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Count instances of the model matched by where from the data source.
   */
  async courierPackageCountRaw(
    requestParameters: CourierPackageCountRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
    const queryParameters: any = {};

    if (requestParameters['where'] != null) {
      queryParameters['where'] = requestParameters['where'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/count`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingCount200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Count instances of the model matched by where from the data source.
   */
  async courierPackageCount(
    requestParameters: CourierPackageCountRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingCount200Response> {
    const response = await this.courierPackageCountRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Create a new instance of the model and persist it into the data source.
   */
  async courierPackageCreateRaw(
    requestParameters: CourierPackageCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierPackage>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: NewCourierPackageToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierPackageFromJSON(jsonValue)
    );
  }

  /**
   * Create a new instance of the model and persist it into the data source.
   */
  async courierPackageCreate(
    requestParameters: CourierPackageCreateRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierPackage> {
    const response = await this.courierPackageCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Create a change stream.
   */
  async courierPackageCreateChangeStreamGetCourierPackagesChangeStreamRaw(
    requestParameters: CourierPackageCreateChangeStreamGetCourierPackagesChangeStreamRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>> {
    const queryParameters: any = {};

    if (requestParameters['options'] != null) {
      queryParameters['options'] = requestParameters['options'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/change-stream`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.BlobApiResponse(response);
  }

  /**
   * Create a change stream.
   */
  async courierPackageCreateChangeStreamGetCourierPackagesChangeStream(
    requestParameters: CourierPackageCreateChangeStreamGetCourierPackagesChangeStreamRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob> {
    const response =
      await this.courierPackageCreateChangeStreamGetCourierPackagesChangeStreamRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Create a change stream.
   */
  async courierPackageCreateChangeStreamPostCourierPackagesChangeStreamRaw(
    requestParameters: CourierPackageCreateChangeStreamPostCourierPackagesChangeStreamRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/change-stream`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON(
          requestParameters[
            'roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest'
          ]
        ),
      },
      initOverrides
    );

    return new runtime.BlobApiResponse(response);
  }

  /**
   * Create a change stream.
   */
  async courierPackageCreateChangeStreamPostCourierPackagesChangeStream(
    requestParameters: CourierPackageCreateChangeStreamPostCourierPackagesChangeStreamRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob> {
    const response =
      await this.courierPackageCreateChangeStreamPostCourierPackagesChangeStreamRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Delete a model instance by {{id}} from the data source.
   */
  async courierPackageDeleteByIdRaw(
    requestParameters: CourierPackageDeleteByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackageDeleteById().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Delete a model instance by {{id}} from the data source.
   */
  async courierPackageDeleteById(
    requestParameters: CourierPackageDeleteByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierPackageDeleteByIdRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Check whether a model instance exists in the data source.
   */
  async courierPackageExistsGetCourierPackagesidExistsRaw(
    requestParameters: CourierPackageExistsGetCourierPackagesidExistsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<
    runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>
  > {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackageExistsGetCourierPackagesidExists().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/exists`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Check whether a model instance exists in the data source.
   */
  async courierPackageExistsGetCourierPackagesidExists(
    requestParameters: CourierPackageExistsGetCourierPackagesidExistsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
    const response =
      await this.courierPackageExistsGetCourierPackagesidExistsRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Check whether a model instance exists in the data source.
   */
  async courierPackageExistsHeadCourierPackagesidRaw(
    requestParameters: CourierPackageExistsHeadCourierPackagesidRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<
    runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>
  > {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackageExistsHeadCourierPackagesid().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'HEAD',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Check whether a model instance exists in the data source.
   */
  async courierPackageExistsHeadCourierPackagesid(
    requestParameters: CourierPackageExistsHeadCourierPackagesidRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
    const response = await this.courierPackageExistsHeadCourierPackagesidRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   */
  async courierPackageExportPackagesToCsvRaw(
    requestParameters: CourierPackageExportPackagesToCsvRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['courierId'] == null) {
      throw new runtime.RequiredError(
        'courierId',
        'Required parameter "courierId" was null or undefined when calling courierPackageExportPackagesToCsv().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/export-packages/{courierId}`.replace(
          `{${'courierId'}}`,
          encodeURIComponent(String(requestParameters['courierId']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async courierPackageExportPackagesToCsv(
    requestParameters: CourierPackageExportPackagesToCsvRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierPackageExportPackagesToCsvRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Find all instances of the model matched by filter from the data source.
   */
  async courierPackageFindRaw(
    requestParameters: CourierPackageFindRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<CourierPackage>>> {
    const queryParameters: any = {};

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CourierPackageFromJSON)
    );
  }

  /**
   * Find all instances of the model matched by filter from the data source.
   */
  async courierPackageFind(
    requestParameters: CourierPackageFindRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<CourierPackage>> {
    const response = await this.courierPackageFindRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Find a model instance by {{id}} from the data source.
   */
  async courierPackageFindByIdRaw(
    requestParameters: CourierPackageFindByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierPackage>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackageFindById().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierPackageFromJSON(jsonValue)
    );
  }

  /**
   * Find a model instance by {{id}} from the data source.
   */
  async courierPackageFindById(
    requestParameters: CourierPackageFindByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierPackage> {
    const response = await this.courierPackageFindByIdRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Find first instance of the model matched by filter from the data source.
   */
  async courierPackageFindOneRaw(
    requestParameters: CourierPackageFindOneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierPackage>> {
    const queryParameters: any = {};

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/findOne`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierPackageFromJSON(jsonValue)
    );
  }

  /**
   * Find first instance of the model matched by filter from the data source.
   */
  async courierPackageFindOne(
    requestParameters: CourierPackageFindOneRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierPackage> {
    const response = await this.courierPackageFindOneRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Import packages from JA Shippers API
   */
  async courierPackageImportFromJaShippersRaw(
    requestParameters: CourierPackageImportFromJaShippersOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    if (
      requestParameters['courierPackageImportFromJaShippersRequest'] == null
    ) {
      throw new runtime.RequiredError(
        'courierPackageImportFromJaShippersRequest',
        'Required parameter "courierPackageImportFromJaShippersRequest" was null or undefined when calling courierPackageImportFromJaShippers().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/import-from-jashippers`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CourierPackageImportFromJaShippersRequestToJSON(
          requestParameters['courierPackageImportFromJaShippersRequest']
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Import packages from JA Shippers API
   */
  async courierPackageImportFromJaShippers(
    requestParameters: CourierPackageImportFromJaShippersOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierPackageImportFromJaShippersRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
     * Import packages from Logis API
     * POST {{BASE_URL}}/CourierPackages/import-from-logis
     * BODY
     * {
    "courierId": "id"
        }
     */
  async courierPackageImportFromLogisRaw(
    courierId: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/import-from-logis`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: {
          courierId,
        },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  async courierPackageImportFromLogis(
    courierId: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierPackageImportFromLogisRaw(
      courierId,
      initOverrides
    );
    return await response.value();
  }

  /**
     * Import packages from OnePlus Courier JA API
     * POST {{BASE_URL}}/CourierPackages/import-from-oneplus
     * BODY
     * {
    "courierId": "id"
        }
     */
  async courierPackageImportFromOnePlusRaw(
    courierId: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/import-from-oneplus`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: {
          courierId,
        },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  async courierPackageImportFromOnePlus(
    courierId: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierPackageImportFromOnePlusRaw(
      courierId,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Import packages from the TR Global Logistics API
   * POST {{BASE_URL}}/CourierPackages/import-from-trglobal
   */
  async courierPackageImportFromTrGlobalRaw(
    courierId: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/import-from-trglobal`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: {
          courierId,
        },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  async courierPackageImportFromTrGlobal(
    courierId: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierPackageImportFromTrGlobalRaw(
      courierId,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Import packages from SpeedzMasterV2 API
   * POST {{BASE_URL}}/CourierPackages/import-from-speedz-master-v2
   */
  async courierPackageImportFromSpeedzMasterV2Raw(
    courierId: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/import-from-speedz-master-v2`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: { courierId },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  async courierPackageImportFromSpeedzMasterV2(
    courierId: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierPackageImportFromSpeedzMasterV2Raw(
      courierId,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Import packages from ShipCorp API
   * POST {{BASE_URL}}/CourierPackages/import-from-shipcorp
   */
  async courierPackageImportFromShipCorpRaw(
    courierId: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/import-from-shipcorp`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: { courierId },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  async courierPackageImportFromShipCorp(
    courierId: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierPackageImportFromShipCorpRaw(
      courierId,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Import packages from ShipBiz API
   * POST {{BASE_URL}}/CourierPackages/import-from-shipbiz
   */
  async courierPackageImportFromShipBizRaw(
    courierId: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/import-from-shipbiz`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: { courierId },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  async courierPackageImportFromShipBiz(
    courierId: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierPackageImportFromShipBizRaw(
      courierId,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Import packages from HNM scraper API
   * POST {{BASE_URL}}/CourierPackages/import-from-hnm
   */
  async courierPackageImportFromHnmRaw(
    courierId: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/import-from-hnm`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: { courierId },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  async courierPackageImportFromHnm(
    courierId: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierPackageImportFromHnmRaw(
      courierId,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Import packages from Cargo JA API
   * POST {{BASE_URL}}/CourierPackages/import-from-cargo-ja
   */
  async courierPackageImportFromCargoJaRaw(
    courierId: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/import-from-cargo-ja`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: { courierId },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  async courierPackageImportFromCargoJa(
    courierId: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierPackageImportFromCargoJaRaw(
      courierId,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Import packages from Farin2Yaad API
   * POST {{BASE_URL}}/CourierPackages/import-from-farin2yaad
   */
  async courierPackageImportFromFarin2YaadRaw(
    courierId: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/import-from-farin2yaad`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: { courierId },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  async courierPackageImportFromFarin2Yaad(
    courierId: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierPackageImportFromFarin2YaadRaw(
      courierId,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Import packages from Atora API
   * POST {{BASE_URL}}/CourierPackages/import-from-atora
   */
  async courierPackageImportFromAtoraRaw(
    courierId: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/import-from-atora`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: { courierId },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  async courierPackageImportFromAtora(
    courierId: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierPackageImportFromAtoraRaw(
      courierId,
      initOverrides
    );
    return await response.value();
  }

  /**
   */
  async courierPackageImportFromJsonWithEmailRaw(
    requestParameters: CourierPackageImportFromJsonWithEmailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['courierId'] == null) {
      throw new runtime.RequiredError(
        'courierId',
        'Required parameter "courierId" was null or undefined when calling courierPackageImportFromJsonWithEmail().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/importFromJsonWithEmail/{courierId}`.replace(
          `{${'courierId'}}`,
          encodeURIComponent(String(requestParameters['courierId']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters['cPackages'] as any,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   */
  async courierPackageImportFromJsonWithEmail(
    requestParameters: CourierPackageImportFromJsonWithEmailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierPackageImportFromJsonWithEmailRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   */
  async courierPackageImportPackagesFromCsvRaw(
    requestParameters: CourierPackageImportPackagesFromCsvOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/importPackagesFromCsv`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CourierPackageImportPackagesFromCsvRequestToJSON(
          requestParameters['courierPackageImportPackagesFromCsvRequest']
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   */
  async courierPackageImportPackagesFromCsv(
    requestParameters: CourierPackageImportPackagesFromCsvOperationRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierPackageImportPackagesFromCsvRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   */
  async courierPackageImportPackagesFromCsvV2Raw(
    requestParameters: CourierPackageImportPackagesFromCsvV2Request,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/importPackagesFromCsvV2`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters['importData'] as any,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   */
  async courierPackageImportPackagesFromCsvV2(
    requestParameters: CourierPackageImportPackagesFromCsvV2Request = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierPackageImportPackagesFromCsvV2Raw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Import packages from CSV using fuzzy matching
   */
  async courierPackageImportPackagesFromCsvFuzzyMatchRaw(
    requestParameters: CourierPackageImportPackagesFromCsvFuzzyMatchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['courierId'] == null) {
      throw new runtime.RequiredError(
        'courierId',
        'Required parameter "courierId" was null or undefined when calling courierPackageImportPackagesFromCsvFuzzyMatch().'
      );
    }

    if (requestParameters['fileName'] == null) {
      throw new runtime.RequiredError(
        'fileName',
        'Required parameter "fileName" was null or undefined when calling courierPackageImportPackagesFromCsvFuzzyMatch().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/importPackagesFromCsvFuzzyMatch`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: {
          courierId: requestParameters['courierId'],
          fileName: requestParameters['fileName'],
        },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Import packages from CSV using fuzzy matching
   */
  async courierPackageImportPackagesFromCsvFuzzyMatch(
    requestParameters: CourierPackageImportPackagesFromCsvFuzzyMatchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierPackageImportPackagesFromCsvFuzzyMatchRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   */
  async courierPackageMarkAsDeliveredRaw(
    requestParameters: CourierPackageMarkAsDeliveredOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<boolean>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/markAsDelivered`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CourierPackageMarkAsDeliveredRequestToJSON(
          requestParameters['courierPackageMarkAsDeliveredRequest']
        ),
      },
      initOverrides
    );

    if (this.isJsonMime(response.headers.get('content-type'))) {
      return new runtime.JSONApiResponse<boolean>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   */
  async courierPackageMarkAsDelivered(
    requestParameters: CourierPackageMarkAsDeliveredOperationRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<boolean> {
    const response = await this.courierPackageMarkAsDeliveredRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Patch an existing model instance or insert a new one into the data source.
   */
  async courierPackagePatchOrCreateRaw(
    requestParameters: CourierPackagePatchOrCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierPackage>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages`,
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: CourierPackageToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierPackageFromJSON(jsonValue)
    );
  }

  /**
   * Patch an existing model instance or insert a new one into the data source.
   */
  async courierPackagePatchOrCreate(
    requestParameters: CourierPackagePatchOrCreateRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierPackage> {
    const response = await this.courierPackagePatchOrCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Counts accessTokens of CourierUser.
   */
  async courierPackagePrototypeCountOwnerAccessTokensRaw(
    requestParameters: CourierPackagePrototypeCountOwnerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeCountOwnerAccessTokens().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['where'] != null) {
      queryParameters['where'] = requestParameters['where'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/accessTokens/count`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingCount200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Counts accessTokens of CourierUser.
   */
  async courierPackagePrototypeCountOwnerAccessTokens(
    requestParameters: CourierPackagePrototypeCountOwnerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingCount200Response> {
    const response =
      await this.courierPackagePrototypeCountOwnerAccessTokensRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Counts courierPackages of CourierUser.
   */
  async courierPackagePrototypeCountOwnerCourierPackagesRaw(
    requestParameters: CourierPackagePrototypeCountOwnerCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeCountOwnerCourierPackages().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['where'] != null) {
      queryParameters['where'] = requestParameters['where'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/courierPackages/count`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingCount200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Counts courierPackages of CourierUser.
   */
  async courierPackagePrototypeCountOwnerCourierPackages(
    requestParameters: CourierPackagePrototypeCountOwnerCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingCount200Response> {
    const response =
      await this.courierPackagePrototypeCountOwnerCourierPackagesRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Counts referrer of CourierUser.
   */
  async courierPackagePrototypeCountOwnerReferrerRaw(
    requestParameters: CourierPackagePrototypeCountOwnerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeCountOwnerReferrer().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['where'] != null) {
      queryParameters['where'] = requestParameters['where'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/referrer/count`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingCount200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Counts referrer of CourierUser.
   */
  async courierPackagePrototypeCountOwnerReferrer(
    requestParameters: CourierPackagePrototypeCountOwnerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingCount200Response> {
    const response = await this.courierPackagePrototypeCountOwnerReferrerRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Counts roleMappings of CourierUser.
   */
  async courierPackagePrototypeCountOwnerRoleMappingsRaw(
    requestParameters: CourierPackagePrototypeCountOwnerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeCountOwnerRoleMappings().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['where'] != null) {
      queryParameters['where'] = requestParameters['where'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/roleMappings/count`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingCount200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Counts roleMappings of CourierUser.
   */
  async courierPackagePrototypeCountOwnerRoleMappings(
    requestParameters: CourierPackagePrototypeCountOwnerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingCount200Response> {
    const response =
      await this.courierPackagePrototypeCountOwnerRoleMappingsRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Counts roles of CourierUser.
   */
  async courierPackagePrototypeCountOwnerRolesRaw(
    requestParameters: CourierPackagePrototypeCountOwnerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeCountOwnerRoles().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['where'] != null) {
      queryParameters['where'] = requestParameters['where'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/roles/count`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingCount200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Counts roles of CourierUser.
   */
  async courierPackagePrototypeCountOwnerRoles(
    requestParameters: CourierPackagePrototypeCountOwnerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingCount200Response> {
    const response = await this.courierPackagePrototypeCountOwnerRolesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates a new instance in courierSetting of this model.
   */
  async courierPackagePrototypeCreateCourierCourierSettingRaw(
    requestParameters: CourierPackagePrototypeCreateCourierCourierSettingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierSettings>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeCreateCourierCourierSetting().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/courier/courierSetting`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CourierSettingsToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierSettingsFromJSON(jsonValue)
    );
  }

  /**
   * Creates a new instance in courierSetting of this model.
   */
  async courierPackagePrototypeCreateCourierCourierSetting(
    requestParameters: CourierPackagePrototypeCreateCourierCourierSettingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierSettings> {
    const response =
      await this.courierPackagePrototypeCreateCourierCourierSettingRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Creates a new instance in invoice of this model.
   */
  async courierPackagePrototypeCreateInvoiceRaw(
    requestParameters: CourierPackagePrototypeCreateInvoiceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Invoice>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeCreateInvoice().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/invoice`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: InvoiceToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InvoiceFromJSON(jsonValue)
    );
  }

  /**
   * Creates a new instance in invoice of this model.
   */
  async courierPackagePrototypeCreateInvoice(
    requestParameters: CourierPackagePrototypeCreateInvoiceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Invoice> {
    const response = await this.courierPackagePrototypeCreateInvoiceRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates a new instance in accessTokens of this model.
   */
  async courierPackagePrototypeCreateOwnerAccessTokensRaw(
    requestParameters: CourierPackagePrototypeCreateOwnerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AccessToken>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeCreateOwnerAccessTokens().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/accessTokens`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: AccessTokenToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AccessTokenFromJSON(jsonValue)
    );
  }

  /**
   * Creates a new instance in accessTokens of this model.
   */
  async courierPackagePrototypeCreateOwnerAccessTokens(
    requestParameters: CourierPackagePrototypeCreateOwnerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AccessToken> {
    const response =
      await this.courierPackagePrototypeCreateOwnerAccessTokensRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Creates a new instance in courierPackages of this model.
   */
  async courierPackagePrototypeCreateOwnerCourierPackagesRaw(
    requestParameters: CourierPackagePrototypeCreateOwnerCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierPackage>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeCreateOwnerCourierPackages().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/courierPackages`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: NewCourierPackageToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierPackageFromJSON(jsonValue)
    );
  }

  /**
   * Creates a new instance in courierPackages of this model.
   */
  async courierPackagePrototypeCreateOwnerCourierPackages(
    requestParameters: CourierPackagePrototypeCreateOwnerCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierPackage> {
    const response =
      await this.courierPackagePrototypeCreateOwnerCourierPackagesRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Creates a new instance in referrer of this model.
   */
  async courierPackagePrototypeCreateOwnerReferrerRaw(
    requestParameters: CourierPackagePrototypeCreateOwnerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeCreateOwnerReferrer().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/referrer`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: NewCourierUserToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierUserFromJSON(jsonValue)
    );
  }

  /**
   * Creates a new instance in referrer of this model.
   */
  async courierPackagePrototypeCreateOwnerReferrer(
    requestParameters: CourierPackagePrototypeCreateOwnerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUser> {
    const response = await this.courierPackagePrototypeCreateOwnerReferrerRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates a new instance in roleMappings of this model.
   */
  async courierPackagePrototypeCreateOwnerRoleMappingsRaw(
    requestParameters: CourierPackagePrototypeCreateOwnerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMapping>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeCreateOwnerRoleMappings().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/roleMappings`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: NewRoleMappingToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingFromJSON(jsonValue)
    );
  }

  /**
   * Creates a new instance in roleMappings of this model.
   */
  async courierPackagePrototypeCreateOwnerRoleMappings(
    requestParameters: CourierPackagePrototypeCreateOwnerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMapping> {
    const response =
      await this.courierPackagePrototypeCreateOwnerRoleMappingsRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Creates a new instance in roles of this model.
   */
  async courierPackagePrototypeCreateOwnerRolesRaw(
    requestParameters: CourierPackagePrototypeCreateOwnerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Role>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeCreateOwnerRoles().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/roles`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: NewRoleToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleFromJSON(jsonValue)
    );
  }

  /**
   * Creates a new instance in roles of this model.
   */
  async courierPackagePrototypeCreateOwnerRoles(
    requestParameters: CourierPackagePrototypeCreateOwnerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Role> {
    const response = await this.courierPackagePrototypeCreateOwnerRolesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Deletes all accessTokens of this model.
   */
  async courierPackagePrototypeDeleteOwnerAccessTokensRaw(
    requestParameters: CourierPackagePrototypeDeleteOwnerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeDeleteOwnerAccessTokens().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/accessTokens`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Deletes all accessTokens of this model.
   */
  async courierPackagePrototypeDeleteOwnerAccessTokens(
    requestParameters: CourierPackagePrototypeDeleteOwnerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierPackagePrototypeDeleteOwnerAccessTokensRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Deletes all courierPackages of this model.
   */
  async courierPackagePrototypeDeleteOwnerCourierPackagesRaw(
    requestParameters: CourierPackagePrototypeDeleteOwnerCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeDeleteOwnerCourierPackages().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/courierPackages`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Deletes all courierPackages of this model.
   */
  async courierPackagePrototypeDeleteOwnerCourierPackages(
    requestParameters: CourierPackagePrototypeDeleteOwnerCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierPackagePrototypeDeleteOwnerCourierPackagesRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Deletes all referrer of this model.
   */
  async courierPackagePrototypeDeleteOwnerReferrerRaw(
    requestParameters: CourierPackagePrototypeDeleteOwnerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeDeleteOwnerReferrer().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/referrer`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Deletes all referrer of this model.
   */
  async courierPackagePrototypeDeleteOwnerReferrer(
    requestParameters: CourierPackagePrototypeDeleteOwnerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierPackagePrototypeDeleteOwnerReferrerRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Deletes all roleMappings of this model.
   */
  async courierPackagePrototypeDeleteOwnerRoleMappingsRaw(
    requestParameters: CourierPackagePrototypeDeleteOwnerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeDeleteOwnerRoleMappings().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/roleMappings`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Deletes all roleMappings of this model.
   */
  async courierPackagePrototypeDeleteOwnerRoleMappings(
    requestParameters: CourierPackagePrototypeDeleteOwnerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierPackagePrototypeDeleteOwnerRoleMappingsRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Deletes all roles of this model.
   */
  async courierPackagePrototypeDeleteOwnerRolesRaw(
    requestParameters: CourierPackagePrototypeDeleteOwnerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeDeleteOwnerRoles().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/roles`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Deletes all roles of this model.
   */
  async courierPackagePrototypeDeleteOwnerRoles(
    requestParameters: CourierPackagePrototypeDeleteOwnerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierPackagePrototypeDeleteOwnerRolesRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Delete a related item by id for accessTokens.
   */
  async courierPackagePrototypeDestroyByIdOwnerAccessTokensRaw(
    requestParameters: CourierPackagePrototypeDestroyByIdOwnerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeDestroyByIdOwnerAccessTokens().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierPackagePrototypeDestroyByIdOwnerAccessTokens().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/accessTokens/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a related item by id for accessTokens.
   */
  async courierPackagePrototypeDestroyByIdOwnerAccessTokens(
    requestParameters: CourierPackagePrototypeDestroyByIdOwnerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierPackagePrototypeDestroyByIdOwnerAccessTokensRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Delete a related item by id for courierPackages.
   */
  async courierPackagePrototypeDestroyByIdOwnerCourierPackagesRaw(
    requestParameters: CourierPackagePrototypeDestroyByIdOwnerCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeDestroyByIdOwnerCourierPackages().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierPackagePrototypeDestroyByIdOwnerCourierPackages().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/courierPackages/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a related item by id for courierPackages.
   */
  async courierPackagePrototypeDestroyByIdOwnerCourierPackages(
    requestParameters: CourierPackagePrototypeDestroyByIdOwnerCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierPackagePrototypeDestroyByIdOwnerCourierPackagesRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Delete a related item by id for referrer.
   */
  async courierPackagePrototypeDestroyByIdOwnerReferrerRaw(
    requestParameters: CourierPackagePrototypeDestroyByIdOwnerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeDestroyByIdOwnerReferrer().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierPackagePrototypeDestroyByIdOwnerReferrer().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/referrer/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a related item by id for referrer.
   */
  async courierPackagePrototypeDestroyByIdOwnerReferrer(
    requestParameters: CourierPackagePrototypeDestroyByIdOwnerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierPackagePrototypeDestroyByIdOwnerReferrerRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Delete a related item by id for roleMappings.
   */
  async courierPackagePrototypeDestroyByIdOwnerRoleMappingsRaw(
    requestParameters: CourierPackagePrototypeDestroyByIdOwnerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeDestroyByIdOwnerRoleMappings().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierPackagePrototypeDestroyByIdOwnerRoleMappings().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/roleMappings/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a related item by id for roleMappings.
   */
  async courierPackagePrototypeDestroyByIdOwnerRoleMappings(
    requestParameters: CourierPackagePrototypeDestroyByIdOwnerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierPackagePrototypeDestroyByIdOwnerRoleMappingsRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Delete a related item by id for roles.
   */
  async courierPackagePrototypeDestroyByIdOwnerRolesRaw(
    requestParameters: CourierPackagePrototypeDestroyByIdOwnerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeDestroyByIdOwnerRoles().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierPackagePrototypeDestroyByIdOwnerRoles().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/roles/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a related item by id for roles.
   */
  async courierPackagePrototypeDestroyByIdOwnerRoles(
    requestParameters: CourierPackagePrototypeDestroyByIdOwnerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierPackagePrototypeDestroyByIdOwnerRolesRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Deletes courierSetting of this model.
   */
  async courierPackagePrototypeDestroyCourierCourierSettingRaw(
    requestParameters: CourierPackagePrototypeDestroyCourierCourierSettingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeDestroyCourierCourierSetting().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/courier/courierSetting`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Deletes courierSetting of this model.
   */
  async courierPackagePrototypeDestroyCourierCourierSetting(
    requestParameters: CourierPackagePrototypeDestroyCourierCourierSettingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierPackagePrototypeDestroyCourierCourierSettingRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Deletes invoice of this model.
   */
  async courierPackagePrototypeDestroyInvoiceRaw(
    requestParameters: CourierPackagePrototypeDestroyInvoiceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeDestroyInvoice().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/invoice`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Deletes invoice of this model.
   */
  async courierPackagePrototypeDestroyInvoice(
    requestParameters: CourierPackagePrototypeDestroyInvoiceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierPackagePrototypeDestroyInvoiceRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Check the existence of roles relation to an item by id.
   */
  async courierPackagePrototypeExistsOwnerRolesRaw(
    requestParameters: CourierPackagePrototypeExistsOwnerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeExistsOwnerRoles().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierPackagePrototypeExistsOwnerRoles().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/roles/rel/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'HEAD',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    if (this.isJsonMime(response.headers.get('content-type'))) {
      return new runtime.JSONApiResponse<boolean>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Check the existence of roles relation to an item by id.
   */
  async courierPackagePrototypeExistsOwnerRoles(
    requestParameters: CourierPackagePrototypeExistsOwnerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<boolean> {
    const response = await this.courierPackagePrototypeExistsOwnerRolesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Find a related item by id for accessTokens.
   */
  async courierPackagePrototypeFindByIdOwnerAccessTokensRaw(
    requestParameters: CourierPackagePrototypeFindByIdOwnerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AccessToken>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeFindByIdOwnerAccessTokens().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierPackagePrototypeFindByIdOwnerAccessTokens().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/accessTokens/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AccessTokenFromJSON(jsonValue)
    );
  }

  /**
   * Find a related item by id for accessTokens.
   */
  async courierPackagePrototypeFindByIdOwnerAccessTokens(
    requestParameters: CourierPackagePrototypeFindByIdOwnerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AccessToken> {
    const response =
      await this.courierPackagePrototypeFindByIdOwnerAccessTokensRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Find a related item by id for courierPackages.
   */
  async courierPackagePrototypeFindByIdOwnerCourierPackagesRaw(
    requestParameters: CourierPackagePrototypeFindByIdOwnerCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierPackage>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeFindByIdOwnerCourierPackages().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierPackagePrototypeFindByIdOwnerCourierPackages().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/courierPackages/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierPackageFromJSON(jsonValue)
    );
  }

  /**
   * Find a related item by id for courierPackages.
   */
  async courierPackagePrototypeFindByIdOwnerCourierPackages(
    requestParameters: CourierPackagePrototypeFindByIdOwnerCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierPackage> {
    const response =
      await this.courierPackagePrototypeFindByIdOwnerCourierPackagesRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Find a related item by id for referrer.
   */
  async courierPackagePrototypeFindByIdOwnerReferrerRaw(
    requestParameters: CourierPackagePrototypeFindByIdOwnerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeFindByIdOwnerReferrer().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierPackagePrototypeFindByIdOwnerReferrer().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/referrer/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierUserFromJSON(jsonValue)
    );
  }

  /**
   * Find a related item by id for referrer.
   */
  async courierPackagePrototypeFindByIdOwnerReferrer(
    requestParameters: CourierPackagePrototypeFindByIdOwnerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUser> {
    const response = await this.courierPackagePrototypeFindByIdOwnerReferrerRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Find a related item by id for roleMappings.
   */
  async courierPackagePrototypeFindByIdOwnerRoleMappingsRaw(
    requestParameters: CourierPackagePrototypeFindByIdOwnerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMapping>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeFindByIdOwnerRoleMappings().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierPackagePrototypeFindByIdOwnerRoleMappings().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/roleMappings/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingFromJSON(jsonValue)
    );
  }

  /**
   * Find a related item by id for roleMappings.
   */
  async courierPackagePrototypeFindByIdOwnerRoleMappings(
    requestParameters: CourierPackagePrototypeFindByIdOwnerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMapping> {
    const response =
      await this.courierPackagePrototypeFindByIdOwnerRoleMappingsRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Find a related item by id for roles.
   */
  async courierPackagePrototypeFindByIdOwnerRolesRaw(
    requestParameters: CourierPackagePrototypeFindByIdOwnerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Role>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeFindByIdOwnerRoles().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierPackagePrototypeFindByIdOwnerRoles().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/roles/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleFromJSON(jsonValue)
    );
  }

  /**
   * Find a related item by id for roles.
   */
  async courierPackagePrototypeFindByIdOwnerRoles(
    requestParameters: CourierPackagePrototypeFindByIdOwnerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Role> {
    const response = await this.courierPackagePrototypeFindByIdOwnerRolesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Fetches belongsTo relation courier.
   */
  async courierPackagePrototypeGetCourierRaw(
    requestParameters: CourierPackagePrototypeGetCourierRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Courier>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeGetCourier().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['refresh'] != null) {
      queryParameters['refresh'] = requestParameters['refresh'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/courier`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierFromJSON(jsonValue)
    );
  }

  /**
   * Fetches belongsTo relation courier.
   */
  async courierPackagePrototypeGetCourier(
    requestParameters: CourierPackagePrototypeGetCourierRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Courier> {
    const response = await this.courierPackagePrototypeGetCourierRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Fetches hasOne relation courierSetting.
   */
  async courierPackagePrototypeGetCourierCourierSettingRaw(
    requestParameters: CourierPackagePrototypeGetCourierCourierSettingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierSettings>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeGetCourierCourierSetting().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['refresh'] != null) {
      queryParameters['refresh'] = requestParameters['refresh'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/courier/courierSetting`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierSettingsFromJSON(jsonValue)
    );
  }

  /**
   * Fetches hasOne relation courierSetting.
   */
  async courierPackagePrototypeGetCourierCourierSetting(
    requestParameters: CourierPackagePrototypeGetCourierCourierSettingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierSettings> {
    const response =
      await this.courierPackagePrototypeGetCourierCourierSettingRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Fetches hasOne relation invoice.
   */
  async courierPackagePrototypeGetInvoiceRaw(
    requestParameters: CourierPackagePrototypeGetInvoiceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Invoice>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeGetInvoice().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['refresh'] != null) {
      queryParameters['refresh'] = requestParameters['refresh'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/invoice`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InvoiceFromJSON(jsonValue)
    );
  }

  /**
   * Fetches hasOne relation invoice.
   */
  async courierPackagePrototypeGetInvoice(
    requestParameters: CourierPackagePrototypeGetInvoiceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Invoice> {
    const response = await this.courierPackagePrototypeGetInvoiceRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Fetches belongsTo relation business.
   */
  async courierPackagePrototypeGetInvoiceBusinessRaw(
    requestParameters: CourierPackagePrototypeGetInvoiceBusinessRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Courier>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeGetInvoiceBusiness().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['refresh'] != null) {
      queryParameters['refresh'] = requestParameters['refresh'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/invoice/business`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierFromJSON(jsonValue)
    );
  }

  /**
   * Fetches belongsTo relation business.
   */
  async courierPackagePrototypeGetInvoiceBusiness(
    requestParameters: CourierPackagePrototypeGetInvoiceBusinessRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Courier> {
    const response = await this.courierPackagePrototypeGetInvoiceBusinessRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Fetches belongsTo relation courierPackage.
   */
  async courierPackagePrototypeGetInvoiceCourierPackageRaw(
    requestParameters: CourierPackagePrototypeGetInvoiceCourierPackageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierPackage>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeGetInvoiceCourierPackage().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['refresh'] != null) {
      queryParameters['refresh'] = requestParameters['refresh'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/invoice/courierPackage`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierPackageFromJSON(jsonValue)
    );
  }

  /**
   * Fetches belongsTo relation courierPackage.
   */
  async courierPackagePrototypeGetInvoiceCourierPackage(
    requestParameters: CourierPackagePrototypeGetInvoiceCourierPackageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierPackage> {
    const response =
      await this.courierPackagePrototypeGetInvoiceCourierPackageRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Fetches belongsTo relation customer.
   */
  async courierPackagePrototypeGetInvoiceCustomerRaw(
    requestParameters: CourierPackagePrototypeGetInvoiceCustomerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeGetInvoiceCustomer().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['refresh'] != null) {
      queryParameters['refresh'] = requestParameters['refresh'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/invoice/customer`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierUserFromJSON(jsonValue)
    );
  }

  /**
   * Fetches belongsTo relation customer.
   */
  async courierPackagePrototypeGetInvoiceCustomer(
    requestParameters: CourierPackagePrototypeGetInvoiceCustomerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUser> {
    const response = await this.courierPackagePrototypeGetInvoiceCustomerRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Fetches belongsTo relation owner.
   */
  async courierPackagePrototypeGetOwnerRaw(
    requestParameters: CourierPackagePrototypeGetOwnerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeGetOwner().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['refresh'] != null) {
      queryParameters['refresh'] = requestParameters['refresh'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierUserFromJSON(jsonValue)
    );
  }

  /**
   * Fetches belongsTo relation owner.
   */
  async courierPackagePrototypeGetOwner(
    requestParameters: CourierPackagePrototypeGetOwnerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUser> {
    const response = await this.courierPackagePrototypeGetOwnerRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Queries accessTokens of CourierUser.
   */
  async courierPackagePrototypeGetOwnerAccessTokensRaw(
    requestParameters: CourierPackagePrototypeGetOwnerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<AccessToken>>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeGetOwnerAccessTokens().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/accessTokens`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(AccessTokenFromJSON)
    );
  }

  /**
   * Queries accessTokens of CourierUser.
   */
  async courierPackagePrototypeGetOwnerAccessTokens(
    requestParameters: CourierPackagePrototypeGetOwnerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<AccessToken>> {
    const response = await this.courierPackagePrototypeGetOwnerAccessTokensRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Queries courierPackages of CourierUser.
   */
  async courierPackagePrototypeGetOwnerCourierPackagesRaw(
    requestParameters: CourierPackagePrototypeGetOwnerCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<CourierPackage>>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeGetOwnerCourierPackages().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/courierPackages`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CourierPackageFromJSON)
    );
  }

  /**
   * Queries courierPackages of CourierUser.
   */
  async courierPackagePrototypeGetOwnerCourierPackages(
    requestParameters: CourierPackagePrototypeGetOwnerCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<CourierPackage>> {
    const response =
      await this.courierPackagePrototypeGetOwnerCourierPackagesRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Queries referrer of CourierUser.
   */
  async courierPackagePrototypeGetOwnerReferrerRaw(
    requestParameters: CourierPackagePrototypeGetOwnerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<CourierUser>>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeGetOwnerReferrer().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/referrer`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CourierUserFromJSON)
    );
  }

  /**
   * Queries referrer of CourierUser.
   */
  async courierPackagePrototypeGetOwnerReferrer(
    requestParameters: CourierPackagePrototypeGetOwnerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<CourierUser>> {
    const response = await this.courierPackagePrototypeGetOwnerReferrerRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Queries roleMappings of CourierUser.
   */
  async courierPackagePrototypeGetOwnerRoleMappingsRaw(
    requestParameters: CourierPackagePrototypeGetOwnerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<RoleMapping>>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeGetOwnerRoleMappings().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/roleMappings`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(RoleMappingFromJSON)
    );
  }

  /**
   * Queries roleMappings of CourierUser.
   */
  async courierPackagePrototypeGetOwnerRoleMappings(
    requestParameters: CourierPackagePrototypeGetOwnerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<RoleMapping>> {
    const response = await this.courierPackagePrototypeGetOwnerRoleMappingsRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Queries roles of CourierUser.
   */
  async courierPackagePrototypeGetOwnerRolesRaw(
    requestParameters: CourierPackagePrototypeGetOwnerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<Role>>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeGetOwnerRoles().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/roles`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(RoleFromJSON)
    );
  }

  /**
   * Queries roles of CourierUser.
   */
  async courierPackagePrototypeGetOwnerRoles(
    requestParameters: CourierPackagePrototypeGetOwnerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<Role>> {
    const response = await this.courierPackagePrototypeGetOwnerRolesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Fetches belongsTo relation storeLocation.
   */
  async courierPackagePrototypeGetStoreLocationRaw(
    requestParameters: CourierPackagePrototypeGetStoreLocationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<StoreLocation>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeGetStoreLocation().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['refresh'] != null) {
      queryParameters['refresh'] = requestParameters['refresh'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/storeLocation`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      StoreLocationFromJSON(jsonValue)
    );
  }

  /**
   * Fetches belongsTo relation storeLocation.
   */
  async courierPackagePrototypeGetStoreLocation(
    requestParameters: CourierPackagePrototypeGetStoreLocationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<StoreLocation> {
    const response = await this.courierPackagePrototypeGetStoreLocationRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Add a related item by id for roles.
   */
  async courierPackagePrototypeLinkOwnerRolesRaw(
    requestParameters: CourierPackagePrototypeLinkOwnerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMapping>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeLinkOwnerRoles().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierPackagePrototypeLinkOwnerRoles().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/roles/rel/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: RoleMappingToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingFromJSON(jsonValue)
    );
  }

  /**
   * Add a related item by id for roles.
   */
  async courierPackagePrototypeLinkOwnerRoles(
    requestParameters: CourierPackagePrototypeLinkOwnerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMapping> {
    const response = await this.courierPackagePrototypeLinkOwnerRolesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Patch attributes for a model instance and persist it into the data source.
   */
  async courierPackagePrototypePatchAttributesRaw(
    requestParameters: CourierPackagePrototypePatchAttributesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierPackage>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypePatchAttributes().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/{id}`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: CourierPackageToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierPackageFromJSON(jsonValue)
    );
  }

  /**
   * Patch attributes for a model instance and persist it into the data source.
   */
  async courierPackagePrototypePatchAttributes(
    requestParameters: CourierPackagePrototypePatchAttributesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierPackage> {
    const response = await this.courierPackagePrototypePatchAttributesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Remove the roles relation to an item by id.
   */
  async courierPackagePrototypeUnlinkOwnerRolesRaw(
    requestParameters: CourierPackagePrototypeUnlinkOwnerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeUnlinkOwnerRoles().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierPackagePrototypeUnlinkOwnerRoles().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/roles/rel/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Remove the roles relation to an item by id.
   */
  async courierPackagePrototypeUnlinkOwnerRoles(
    requestParameters: CourierPackagePrototypeUnlinkOwnerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.courierPackagePrototypeUnlinkOwnerRolesRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Update a related item by id for accessTokens.
   */
  async courierPackagePrototypeUpdateByIdOwnerAccessTokensRaw(
    requestParameters: CourierPackagePrototypeUpdateByIdOwnerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AccessToken>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeUpdateByIdOwnerAccessTokens().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierPackagePrototypeUpdateByIdOwnerAccessTokens().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/accessTokens/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: AccessTokenToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AccessTokenFromJSON(jsonValue)
    );
  }

  /**
   * Update a related item by id for accessTokens.
   */
  async courierPackagePrototypeUpdateByIdOwnerAccessTokens(
    requestParameters: CourierPackagePrototypeUpdateByIdOwnerAccessTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AccessToken> {
    const response =
      await this.courierPackagePrototypeUpdateByIdOwnerAccessTokensRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Update a related item by id for courierPackages.
   */
  async courierPackagePrototypeUpdateByIdOwnerCourierPackagesRaw(
    requestParameters: CourierPackagePrototypeUpdateByIdOwnerCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierPackage>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeUpdateByIdOwnerCourierPackages().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierPackagePrototypeUpdateByIdOwnerCourierPackages().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/courierPackages/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: CourierPackageToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierPackageFromJSON(jsonValue)
    );
  }

  /**
   * Update a related item by id for courierPackages.
   */
  async courierPackagePrototypeUpdateByIdOwnerCourierPackages(
    requestParameters: CourierPackagePrototypeUpdateByIdOwnerCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierPackage> {
    const response =
      await this.courierPackagePrototypeUpdateByIdOwnerCourierPackagesRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Update a related item by id for referrer.
   */
  async courierPackagePrototypeUpdateByIdOwnerReferrerRaw(
    requestParameters: CourierPackagePrototypeUpdateByIdOwnerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierUser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeUpdateByIdOwnerReferrer().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierPackagePrototypeUpdateByIdOwnerReferrer().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/referrer/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: CourierUserToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierUserFromJSON(jsonValue)
    );
  }

  /**
   * Update a related item by id for referrer.
   */
  async courierPackagePrototypeUpdateByIdOwnerReferrer(
    requestParameters: CourierPackagePrototypeUpdateByIdOwnerReferrerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierUser> {
    const response =
      await this.courierPackagePrototypeUpdateByIdOwnerReferrerRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Update a related item by id for roleMappings.
   */
  async courierPackagePrototypeUpdateByIdOwnerRoleMappingsRaw(
    requestParameters: CourierPackagePrototypeUpdateByIdOwnerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMapping>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeUpdateByIdOwnerRoleMappings().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierPackagePrototypeUpdateByIdOwnerRoleMappings().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/roleMappings/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: RoleMappingToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingFromJSON(jsonValue)
    );
  }

  /**
   * Update a related item by id for roleMappings.
   */
  async courierPackagePrototypeUpdateByIdOwnerRoleMappings(
    requestParameters: CourierPackagePrototypeUpdateByIdOwnerRoleMappingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMapping> {
    const response =
      await this.courierPackagePrototypeUpdateByIdOwnerRoleMappingsRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Update a related item by id for roles.
   */
  async courierPackagePrototypeUpdateByIdOwnerRolesRaw(
    requestParameters: CourierPackagePrototypeUpdateByIdOwnerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Role>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeUpdateByIdOwnerRoles().'
      );
    }

    if (requestParameters['fk'] == null) {
      throw new runtime.RequiredError(
        'fk',
        'Required parameter "fk" was null or undefined when calling courierPackagePrototypeUpdateByIdOwnerRoles().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/owner/roles/{fk}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'fk'}}`,
            encodeURIComponent(String(requestParameters['fk']))
          ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: RoleToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleFromJSON(jsonValue)
    );
  }

  /**
   * Update a related item by id for roles.
   */
  async courierPackagePrototypeUpdateByIdOwnerRoles(
    requestParameters: CourierPackagePrototypeUpdateByIdOwnerRolesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Role> {
    const response = await this.courierPackagePrototypeUpdateByIdOwnerRolesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Update courierSetting of this model.
   */
  async courierPackagePrototypeUpdateCourierCourierSettingRaw(
    requestParameters: CourierPackagePrototypeUpdateCourierCourierSettingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierSettings>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeUpdateCourierCourierSetting().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/courier/courierSetting`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: CourierSettingsToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierSettingsFromJSON(jsonValue)
    );
  }

  /**
   * Update courierSetting of this model.
   */
  async courierPackagePrototypeUpdateCourierCourierSetting(
    requestParameters: CourierPackagePrototypeUpdateCourierCourierSettingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierSettings> {
    const response =
      await this.courierPackagePrototypeUpdateCourierCourierSettingRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Update invoice of this model.
   */
  async courierPackagePrototypeUpdateInvoiceRaw(
    requestParameters: CourierPackagePrototypeUpdateInvoiceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Invoice>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackagePrototypeUpdateInvoice().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/invoice`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: InvoiceToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InvoiceFromJSON(jsonValue)
    );
  }

  /**
   * Update invoice of this model.
   */
  async courierPackagePrototypeUpdateInvoice(
    requestParameters: CourierPackagePrototypeUpdateInvoiceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Invoice> {
    const response = await this.courierPackagePrototypeUpdateInvoiceRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Replace attributes for a model instance and persist it into the data source.
   */
  async courierPackageReplaceByIdPostCourierPackagesidReplaceRaw(
    requestParameters: CourierPackageReplaceByIdPostCourierPackagesidReplaceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierPackage>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackageReplaceByIdPostCourierPackagesidReplace().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/replace`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CourierPackageToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierPackageFromJSON(jsonValue)
    );
  }

  /**
   * Replace attributes for a model instance and persist it into the data source.
   */
  async courierPackageReplaceByIdPostCourierPackagesidReplace(
    requestParameters: CourierPackageReplaceByIdPostCourierPackagesidReplaceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierPackage> {
    const response =
      await this.courierPackageReplaceByIdPostCourierPackagesidReplaceRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Replace attributes for a model instance and persist it into the data source.
   */
  async courierPackageReplaceByIdPutCourierPackagesidRaw(
    requestParameters: CourierPackageReplaceByIdPutCourierPackagesidRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierPackage>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackageReplaceByIdPutCourierPackagesid().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/{id}`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: CourierPackageToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierPackageFromJSON(jsonValue)
    );
  }

  /**
   * Replace attributes for a model instance and persist it into the data source.
   */
  async courierPackageReplaceByIdPutCourierPackagesid(
    requestParameters: CourierPackageReplaceByIdPutCourierPackagesidRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierPackage> {
    const response =
      await this.courierPackageReplaceByIdPutCourierPackagesidRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Replace an existing model instance or insert a new one into the data source.
   */
  async courierPackageReplaceOrCreatePostCourierPackagesReplaceOrCreateRaw(
    requestParameters: CourierPackageReplaceOrCreatePostCourierPackagesReplaceOrCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierPackage>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/replaceOrCreate`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CourierPackageToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierPackageFromJSON(jsonValue)
    );
  }

  /**
   * Replace an existing model instance or insert a new one into the data source.
   */
  async courierPackageReplaceOrCreatePostCourierPackagesReplaceOrCreate(
    requestParameters: CourierPackageReplaceOrCreatePostCourierPackagesReplaceOrCreateRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierPackage> {
    const response =
      await this.courierPackageReplaceOrCreatePostCourierPackagesReplaceOrCreateRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Replace an existing model instance or insert a new one into the data source.
   */
  async courierPackageReplaceOrCreatePutCourierPackagesRaw(
    requestParameters: CourierPackageReplaceOrCreatePutCourierPackagesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierPackage>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages`,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: CourierPackageToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierPackageFromJSON(jsonValue)
    );
  }

  /**
   * Replace an existing model instance or insert a new one into the data source.
   */
  async courierPackageReplaceOrCreatePutCourierPackages(
    requestParameters: CourierPackageReplaceOrCreatePutCourierPackagesRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierPackage> {
    const response =
      await this.courierPackageReplaceOrCreatePutCourierPackagesRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   */
  async courierPackageTrackViaWhatsAppRaw(
    requestParameters: CourierPackageTrackViaWhatsAppRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<string>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/trackViaWhatsApp`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CourierUserCreateWhatsAppUserRequestToJSON(
          requestParameters['courierUserCreateWhatsAppUserRequest']
        ),
      },
      initOverrides
    );

    if (this.isJsonMime(response.headers.get('content-type'))) {
      return new runtime.JSONApiResponse<string>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   */
  async courierPackageTrackViaWhatsApp(
    requestParameters: CourierPackageTrackViaWhatsAppRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<string> {
    const response = await this.courierPackageTrackViaWhatsAppRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Update instances of the model matched by {{where}} from the data source.
   */
  async courierPackageUpdateAllRaw(
    requestParameters: CourierPackageUpdateAllRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMappingUpdateAll200Response>> {
    const queryParameters: any = {};

    if (requestParameters['where'] != null) {
      queryParameters['where'] = requestParameters['where'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/update`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CourierPackageToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingUpdateAll200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Update instances of the model matched by {{where}} from the data source.
   */
  async courierPackageUpdateAll(
    requestParameters: CourierPackageUpdateAllRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingUpdateAll200Response> {
    const response = await this.courierPackageUpdateAllRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   */
  async courierPackageUpdatePackageStatusRaw(
    requestParameters: CourierPackageUpdatePackageStatusOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<boolean>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/updatePackageStatus`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CourierPackageUpdatePackageStatusRequestToJSON(
          requestParameters['courierPackageUpdatePackageStatusRequest']
        ),
      },
      initOverrides
    );

    if (this.isJsonMime(response.headers.get('content-type'))) {
      return new runtime.JSONApiResponse<boolean>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   */
  async courierPackageUpdatePackageStatus(
    requestParameters: CourierPackageUpdatePackageStatusOperationRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<boolean> {
    const response = await this.courierPackageUpdatePackageStatusRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Update an existing model instance or insert a new one into the data source based on the where criteria.
   */
  async courierPackageUpsertWithWhereRaw(
    requestParameters: CourierPackageUpsertWithWhereRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierPackage>> {
    const queryParameters: any = {};

    if (requestParameters['where'] != null) {
      queryParameters['where'] = requestParameters['where'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/upsertWithWhere`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CourierPackageToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierPackageFromJSON(jsonValue)
    );
  }

  /**
   * Update an existing model instance or insert a new one into the data source based on the where criteria.
   */
  async courierPackageUpsertWithWhere(
    requestParameters: CourierPackageUpsertWithWhereRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierPackage> {
    const response = await this.courierPackageUpsertWithWhereRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Update attachments for a package using updateAll to bypass observers
   */
  async courierPackageUpdateAttachmentsRaw(
    requestParameters: CourierPackageUpdateAttachmentsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RoleMappingUpdateAll200Response>> {
    if (requestParameters['packageId'] == null) {
      throw new runtime.RequiredError(
        'packageId',
        'Required parameter "packageId" was null or undefined when calling courierPackageUpdateAttachments().'
      );
    }

    if (requestParameters['value'] == null) {
      throw new runtime.RequiredError(
        'value',
        'Required parameter "value" was null or undefined when calling courierPackageUpdateAttachments().'
      );
    }

    if (requestParameters['attachments'] == null) {
      throw new runtime.RequiredError(
        'attachments',
        'Required parameter "attachments" was null or undefined when calling courierPackageUpdateAttachments().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/updateAttachments`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: {
          packageId: requestParameters['packageId'],
          value: requestParameters['value'],
          attachments: requestParameters['attachments'],
        },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleMappingUpdateAll200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Update attachments for a package using updateAll to bypass observers
   */
  async courierPackageUpdateAttachments(
    requestParameters: CourierPackageUpdateAttachmentsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RoleMappingUpdateAll200Response> {
    const response = await this.courierPackageUpdateAttachmentsRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Generate a printable label PDF for a package
   */
  async courierPackageGenerateLabelPDFRaw(
    requestParameters: CourierPackageGenerateLabelPDFRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>> {
    if (requestParameters['packageId'] == null) {
      throw new runtime.RequiredError(
        'packageId',
        'Required parameter "packageId" was null or undefined when calling courierPackageGenerateLabelPDF().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/${encodeURIComponent(String(requestParameters['packageId']))}/label`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.BlobApiResponse(response);
  }

  /**
   * Generate a printable label PDF for a package
   */
  async courierPackageGenerateLabelPDF(
    requestParameters: CourierPackageGenerateLabelPDFRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob> {
    const response = await this.courierPackageGenerateLabelPDFRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Generate printable labels PDF for multiple packages
   */
  async courierPackageGenerateBulkLabelsRaw(
    requestParameters: CourierPackageGenerateBulkLabelsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>> {
    if (requestParameters['packageIds'] == null) {
      throw new runtime.RequiredError(
        'packageIds',
        'Required parameter "packageIds" was null or undefined when calling courierPackageGenerateBulkLabels().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/bulk-labels`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters['packageIds'],
      },
      initOverrides
    );

    return new runtime.BlobApiResponse(response);
  }

  /**
   * Generate printable labels PDF for multiple packages
   */
  async courierPackageGenerateBulkLabels(
    requestParameters: CourierPackageGenerateBulkLabelsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob> {
    const response = await this.courierPackageGenerateBulkLabelsRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  async courierPackageMarkAsUnknownRaw(
    requestParameters: { packageId: number; isUnknown?: boolean },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierPackage>> {
    if (requestParameters['packageId'] == null) {
      throw new runtime.RequiredError(
        'packageId',
        'Required parameter "packageId" was null or undefined when calling courierPackageMarkAsUnknown().'
      );
    }

    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/mark-as-unknown`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: {
          packageId: requestParameters['packageId'],
          isUnknown: requestParameters['isUnknown'] ?? true,
        },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierPackageFromJSON(jsonValue)
    );
  }

  async courierPackageMarkAsUnknown(
    requestParameters: { packageId: number; isUnknown?: boolean },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierPackage> {
    const response = await this.courierPackageMarkAsUnknownRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Reassign a package to one of this courier's OWN customers, detaching it from
   * any partner sub-courier. Distinct from PackageClaims/assign-package, which
   * hands a package to a sub-courier tenant.
   */
  /**
   * Pull the packages a courier's PARTNER warehouses (OX tenants reached
   * through a PartnerLink, not a vendor API) are holding into its own tenant.
   * This is the "Import Latest" action on Warehouse Management for couriers
   * that have no vendor warehouse integration.
   */
  async courierPackageImportPartnerWarehousePackagesRaw(
    requestParameters: {
      data: { courierId: number | string; since?: string; limit?: number };
    },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<
    runtime.ApiResponse<{
      created: number;
      updated: number;
      skipped: number;
      total: number;
      warehouses: number;
    }>
  > {
    if (requestParameters['data'] == null) {
      throw new runtime.RequiredError(
        'data',
        'Required parameter "data" was null or undefined when calling courierPackageImportPartnerWarehousePackages().'
      );
    }

    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/import-partner-warehouse-packages`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters['data'],
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response);
  }

  async courierPackageImportPartnerWarehousePackages(
    requestParameters: {
      data: { courierId: number | string; since?: string; limit?: number };
    },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{
    created: number;
    updated: number;
    skipped: number;
    total: number;
    warehouses: number;
  }> {
    const response =
      await this.courierPackageImportPartnerWarehousePackagesRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  async courierPackageReassignToOwnCustomerRaw(
    requestParameters: {
      data: { packageId: number; ownerId: number; notes?: string };
    },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierPackage>> {
    if (requestParameters['data'] == null) {
      throw new runtime.RequiredError(
        'data',
        'Required parameter "data" was null or undefined when calling courierPackageReassignToOwnCustomer().'
      );
    }

    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/reassign-to-own-customer`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters['data'],
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CourierPackageFromJSON(jsonValue)
    );
  }

  async courierPackageReassignToOwnCustomer(
    requestParameters: {
      data: { packageId: number; ownerId: number; notes?: string };
    },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierPackage> {
    const response = await this.courierPackageReassignToOwnCustomerRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Force-resync a single warehouse package to the partner sub-courier.
   */
  async courierPackageResyncPartnerPackageRaw(
    requestParameters: { packageId: number },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['packageId'] == null) {
      throw new runtime.RequiredError(
        'packageId',
        'Required parameter "packageId" was null or undefined when calling courierPackageResyncPartnerPackage().'
      );
    }

    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/resync-partner-package`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: {
          packageId: requestParameters['packageId'],
        },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<object>(response);
  }

  async courierPackageResyncPartnerPackage(
    requestParameters: { packageId: number },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierPackageResyncPartnerPackageRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Bulk resync warehouse packages to partner sub-couriers.
   */
  async courierPackageBulkResyncPartnerPackagesRaw(
    requestParameters: { packageIds: number[] },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object[]>> {
    if (requestParameters['packageIds'] == null) {
      throw new runtime.RequiredError(
        'packageIds',
        'Required parameter "packageIds" was null or undefined when calling courierPackageBulkResyncPartnerPackages().'
      );
    }

    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/bulk-resync-partner-packages`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: {
          packageIds: requestParameters['packageIds'],
        },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<object[]>(response);
  }

  async courierPackageBulkResyncPartnerPackages(
    requestParameters: { packageIds: number[] },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object[]> {
    const response = await this.courierPackageBulkResyncPartnerPackagesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Resync warehouse packages to sub-couriers for a date range.
   * Recovers from missed after-save propagation.
   */
  async courierPackageResyncPartnerPackagesByDateRangeRaw(
    requestParameters: {
      courierId: number;
      startDate: string;
      endDate: string;
      dryRun?: boolean;
    },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['courierId'] == null) {
      throw new runtime.RequiredError(
        'courierId',
        'Required parameter "courierId" was null or undefined when calling courierPackageResyncPartnerPackagesByDateRange().'
      );
    }
    if (requestParameters['startDate'] == null) {
      throw new runtime.RequiredError(
        'startDate',
        'Required parameter "startDate" was null or undefined when calling courierPackageResyncPartnerPackagesByDateRange().'
      );
    }
    if (requestParameters['endDate'] == null) {
      throw new runtime.RequiredError(
        'endDate',
        'Required parameter "endDate" was null or undefined when calling courierPackageResyncPartnerPackagesByDateRange().'
      );
    }

    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/resync-partner-packages-by-date-range`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: {
          courierId: requestParameters['courierId'],
          startDate: requestParameters['startDate'],
          endDate: requestParameters['endDate'],
          dryRun: requestParameters['dryRun'],
        },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<object>(response);
  }

  async courierPackageResyncPartnerPackagesByDateRange(
    requestParameters: {
      courierId: number;
      startDate: string;
      endDate: string;
      dryRun?: boolean;
    },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierPackageResyncPartnerPackagesByDateRangeRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Close out warehouse packages whose sub-courier copy is already Delivered.
   * Backfill for records stuck at Ready before the reverse status sync existed.
   */
  async courierPackageSyncDeliveredFromSubCouriersRaw(
    requestParameters: {
      courierId: number;
      startDate: string;
      endDate: string;
      dryRun?: boolean;
    },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['courierId'] == null) {
      throw new runtime.RequiredError(
        'courierId',
        'Required parameter "courierId" was null or undefined when calling courierPackageSyncDeliveredFromSubCouriers().'
      );
    }
    if (requestParameters['startDate'] == null) {
      throw new runtime.RequiredError(
        'startDate',
        'Required parameter "startDate" was null or undefined when calling courierPackageSyncDeliveredFromSubCouriers().'
      );
    }
    if (requestParameters['endDate'] == null) {
      throw new runtime.RequiredError(
        'endDate',
        'Required parameter "endDate" was null or undefined when calling courierPackageSyncDeliveredFromSubCouriers().'
      );
    }

    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/sync-delivered-from-sub-couriers`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: {
          courierId: requestParameters['courierId'],
          startDate: requestParameters['startDate'],
          endDate: requestParameters['endDate'],
          dryRun: requestParameters['dryRun'],
        },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<object>(response);
  }

  async courierPackageSyncDeliveredFromSubCouriers(
    requestParameters: {
      courierId: number;
      startDate: string;
      endDate: string;
      dryRun?: boolean;
    },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierPackageSyncDeliveredFromSubCouriersRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Record each warehouse package's sub-courier reported status, and with
   * advanceStatus also pull a warehouse row still sitting behind "Ready"
   * forward to "Ready" when its sub-courier is already past handoff.
   *
   * This is the repair for a package handed to the sub-courier without being
   * scanned: warehouse billing only charges Ready-or-past, so the row was
   * invisible and uncharged. It never sets "Delivered" and never generates an
   * invoice — billing stays a deliberate step.
   *
   * Run it with dryRun first: the response lists each candidate with an
   * `advanceTo` so staff can see the moves before committing.
   */
  async courierPackageBackfillSubCourierStatusRaw(
    requestParameters: {
      courierId: number;
      startDate: string;
      endDate: string;
      dryRun?: boolean;
      advanceStatus?: boolean;
    },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['courierId'] == null) {
      throw new runtime.RequiredError(
        'courierId',
        'Required parameter "courierId" was null or undefined when calling courierPackageBackfillSubCourierStatus().'
      );
    }
    if (requestParameters['startDate'] == null) {
      throw new runtime.RequiredError(
        'startDate',
        'Required parameter "startDate" was null or undefined when calling courierPackageBackfillSubCourierStatus().'
      );
    }
    if (requestParameters['endDate'] == null) {
      throw new runtime.RequiredError(
        'endDate',
        'Required parameter "endDate" was null or undefined when calling courierPackageBackfillSubCourierStatus().'
      );
    }

    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/backfill-sub-courier-status`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: {
          courierId: requestParameters['courierId'],
          startDate: requestParameters['startDate'],
          endDate: requestParameters['endDate'],
          dryRun: requestParameters['dryRun'],
          advanceStatus: requestParameters['advanceStatus'],
        },
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<object>(response);
  }

  async courierPackageBackfillSubCourierStatus(
    requestParameters: {
      courierId: number;
      startDate: string;
      endDate: string;
      dryRun?: boolean;
      advanceStatus?: boolean;
    },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierPackageBackfillSubCourierStatusRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Analyze a package label image using AI to extract customer name, courier prefix, and match to partner couriers
   */
  async courierPackageAnalyzeLabelRaw(
    requestParameters: {
      imageFileName: string;
      courierId: string;
      itemImageFileName?: string;
      itemImageFileNames?: string[];
      lockedCourierId?: number;
    },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['imageFileName'] == null) {
      throw new runtime.RequiredError(
        'imageFileName',
        'Required parameter "imageFileName" was null or undefined when calling courierPackageAnalyzeLabel().'
      );
    }
    if (requestParameters['courierId'] == null) {
      throw new runtime.RequiredError(
        'courierId',
        'Required parameter "courierId" was null or undefined when calling courierPackageAnalyzeLabel().'
      );
    }

    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const body: any = {
      imageFileName: requestParameters['imageFileName'],
      courierId: requestParameters['courierId'],
    };
    if (requestParameters['itemImageFileName']) {
      body.itemImageFileName = requestParameters['itemImageFileName'];
    }
    if (requestParameters['itemImageFileNames']?.length) {
      body.itemImageFileNames = requestParameters['itemImageFileNames'];
    }
    if (requestParameters['lockedCourierId'] != null) {
      body.lockedCourierId = requestParameters['lockedCourierId'];
    }

    const response = await this.request(
      {
        path: `/CourierPackages/analyze-label`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<object>(response);
  }

  /**
   * Analyze a package label image using AI to extract customer name, courier prefix, and match to partner couriers.
   * Optionally accepts an item image to auto-generate a description.
   */
  async courierPackageAnalyzeLabel(
    requestParameters: {
      imageFileName: string;
      courierId: string;
      itemImageFileName?: string;
      itemImageFileNames?: string[];
      lockedCourierId?: number;
    },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierPackageAnalyzeLabelRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Daily SmartScan counter: { mine, team } — packages scanned today by the current user vs. the whole courier (Jamaica-timezone day).
   */
  async courierPackageGetScanStatsRaw(
    requestParameters: {
      courierId: number;
    },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<{ mine: number; team: number }>> {
    if (requestParameters['courierId'] == null) {
      throw new runtime.RequiredError(
        'courierId',
        'Required parameter "courierId" was null or undefined when calling courierPackageGetScanStats().'
      );
    }

    const queryParameters: any = {};
    if (requestParameters['courierId'] != null) {
      queryParameters['courierId'] = requestParameters['courierId'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/scan-stats`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<{ mine: number; team: number }>(
      response
    );
  }

  /**
   * Daily SmartScan counter: { mine, team } — packages scanned today by the current user vs. the whole courier (Jamaica-timezone day).
   */
  async courierPackageGetScanStats(
    requestParameters: {
      courierId: number;
    },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{ mine: number; team: number }> {
    const response = await this.courierPackageGetScanStatsRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Clear the assignment-review flag after a human has verified the package owner is correct.
   */
  async courierPackageConfirmAssignmentRaw(
    requestParameters: {
      id: number | string;
    },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<
    runtime.ApiResponse<{
      id: number;
      needsAssignmentReview: boolean;
      assignmentReviewedBy?: number;
      assignmentReviewedAt?: string;
    }>
  > {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackageConfirmAssignment().'
      );
    }

    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/confirm-assignment`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<{
      id: number;
      needsAssignmentReview: boolean;
      assignmentReviewedBy?: number;
      assignmentReviewedAt?: string;
    }>(response);
  }

  /**
   * Clear the assignment-review flag after a human has verified the package owner is correct.
   * The flag cannot be lowered by an ordinary update — this is the only way to clear it.
   */
  async courierPackageConfirmAssignment(
    requestParameters: {
      id: number | string;
    },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{
    id: number;
    needsAssignmentReview: boolean;
    assignmentReviewedBy?: number;
    assignmentReviewedAt?: string;
  }> {
    const response = await this.courierPackageConfirmAssignmentRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Dismiss the SmartScan invoice-review flag (no invoice needed / handled elsewhere).
   */
  async courierPackageDismissInvoiceReviewRaw(
    requestParameters: {
      id: number | string;
    },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierPackageDismissInvoiceReviewResult>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling courierPackageDismissInvoiceReview().'
      );
    }

    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/{id}/dismiss-invoice-review`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<CourierPackageDismissInvoiceReviewResult>(
      response
    );
  }

  /**
   * Dismiss the SmartScan invoice-review flag (no invoice needed / handled elsewhere).
   * A dismissed package is never re-flagged by the hourly sweep.
   */
  async courierPackageDismissInvoiceReview(
    requestParameters: {
      id: number | string;
    },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierPackageDismissInvoiceReviewResult> {
    const response = await this.courierPackageDismissInvoiceReviewRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Run the SmartScan invoice-review sweep (AI value estimate + high value / heavy flags) for your courier now.
   */
  async courierPackageRunInvoiceReviewRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CourierPackageInvoiceReviewSweepResult>> {
    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/CourierPackages/run-invoice-review`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<CourierPackageInvoiceReviewSweepResult>(
      response
    );
  }

  /**
   * Run the SmartScan invoice-review sweep for your courier now.
   */
  async courierPackageRunInvoiceReview(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CourierPackageInvoiceReviewSweepResult> {
    const response = await this.courierPackageRunInvoiceReviewRaw(
      initOverrides
    );
    return await response.value();
  }

  /**
   * Describe a package's contents from photo(s) using AI, returning a short itemDescription (two-step SmartScan Step 2).
   */
  async courierPackageDescribePackageContentsRaw(
    requestParameters: {
      courierId: string;
      itemImageFileNames?: string[];
      itemImageFileName?: string;
    },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['courierId'] == null) {
      throw new runtime.RequiredError(
        'courierId',
        'Required parameter "courierId" was null or undefined when calling courierPackageDescribePackageContents().'
      );
    }

    const queryParameters: any = {};
    const headerParameters: runtime.HTTPHeaders = {};
    headerParameters['Content-Type'] = 'application/json';

    const body: any = {
      courierId: requestParameters['courierId'],
    };
    if (requestParameters['itemImageFileNames']?.length) {
      body.itemImageFileNames = requestParameters['itemImageFileNames'];
    }
    if (requestParameters['itemImageFileName']) {
      body.itemImageFileName = requestParameters['itemImageFileName'];
    }

    const response = await this.request(
      {
        path: `/CourierPackages/describe-package-contents`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<object>(response);
  }

  /**
   * Describe a package's contents from photo(s) using AI, returning a short itemDescription (two-step SmartScan Step 2).
   */
  async courierPackageDescribePackageContents(
    requestParameters: {
      courierId: string;
      itemImageFileNames?: string[];
      itemImageFileName?: string;
    },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.courierPackageDescribePackageContentsRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Search packages by customer/owner name with server-side join.
   * Returns { data: CourierPackage[], count: number }
   */
  async courierPackageSearchByOwnerNameRaw(
    requestParameters: { courierId: number; query: string; filter?: string },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<{ data: any[]; count: number }>> {
    const queryParameters: any = {};
    queryParameters['courierId'] = requestParameters['courierId'];
    queryParameters['query'] = requestParameters['query'];
    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/CourierPackages/searchByOwnerName`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response);
  }

  async courierPackageSearchByOwnerName(
    requestParameters: { courierId: number; query: string; filter?: string },
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{ data: any[]; count: number }> {
    const response = await this.courierPackageSearchByOwnerNameRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }
}
